import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Button } from 'antd';
import i18next from 'i18next';
import { convertObjToSearchStr } from 'utils/tools';
import PageTitle from 'components/common/PageTitle';
import { useHistory, useParams } from 'react-router';
// import PagesList from 'containers/Pages/List';

import NichesList from 'containers/Niches/List';
import PlatformsList from 'containers/Platforms/List';
import SettingStyle from './styles';

const { TabPane } = Tabs;

const TABS = [
  {
    key: 'niches',
    text: 'tabs.niches',
    url: '/niches',
    component: NichesList,
  },
  {
    key: 'platforms',
    text: 'tabs.platforms',
    url: '/platforms',
    component: PlatformsList,
  },
];

const Settings = ({ ...props }) => {
  const history = useHistory();
  const params = useParams();
  const onChange = (key) => {
    history.push(`/settings/${key}`);
  };
  const gotoCreatePage = () => {
    const { redirects, rootPath, initCreateData } = props;
    const route = `${rootPath}/${params.model}/create`;
    if (redirects.create === 'modal') {
      history.push(
        `#${params.model}/create?${convertObjToSearchStr(initCreateData)}`,
      );
    } else {
      history.push(route);
    }
  };
  return (
    <SettingStyle>
      <div className="page-header">
        <PageTitle>{i18next.t('settings.header')}</PageTitle>
        <Button type="primary" onClick={gotoCreatePage}>
          {i18next.t('button.create')}
        </Button>
      </div>
      <Tabs
        type="card"
        defaultActiveKey={params.model || 'rooms'}
        onChange={onChange}
      >
        {TABS.map((tab) => (
          <TabPane tab={i18next.t(tab.text)} key={tab.key}>
            <tab.component
              rootPath="/settings"
              noCardWrapper
              layoutButtonCreate="non-inline"
              {...props}
            />
          </TabPane>
        ))}
      </Tabs>
    </SettingStyle>
  );
};

Settings.propTypes = {
  match: PropTypes.object,
  redirects: PropTypes.object,
  rootPath: PropTypes.string,
  initCreateData: PropTypes.object,
};

Settings.defaultProps = {
  rootPath: '/settings',
  redirects: {
    edit: 'modal',
    create: 'modal',
  },
  initCreateData: {},
};

export default Settings;
